// Import styles
import './styles/main.scss';

// Import vendor scripts
import './scripts/jquery.fancybox.js';
import './scripts/jquery.flexslider.js';
// import './scripts/jquery.sparkbox-select.js';
import './scripts/jquery.superfish';
import './scripts/jquery.superLabels.min.js';
import './scripts/slick.js';
// import './scripts/modernizr-1.7.min.js';
import './scripts/loadmore.js';

// Import main script
import './scripts/app.js';